import { FunctionComponent } from 'react';
import HanTableContainer from '../../../utils/han-table-components/HanTableContainer';
import HanTable, {HanTableHead} from '../../../utils/han-table-components/HanTable';
import HanTableRow from '../../../utils/han-table-components/HanTableRow';
import HanTableCell from '../../../utils/han-table-components/HanTableCell';
import FormQuestion from '../../../../networking/models/FormQuestion';
import {UniversityPart} from '../../../../networking/repos/UniversityRepository';

export interface Part {
    id: number;
    title: string;
    labels: string[];
    answers: string[][];
}

export interface PartSection {
    title: string;
    parts: Part[];
}

export const partsToPartSections = (parts: UniversityPart[]) => {
    return parts.reduce((parts: PartSection[], current) => {
        let index = parts.findIndex(part => part.title === current.name);

        if(index === -1) {
            parts.push({ title: current.name, parts: [] });
            index = parts.length - 1;
        }

        parts[index].parts = fillParts(parts[index].parts, current.active_questions);

        return parts;
    }, []);
};

export const fillParts = (parts: Part[], questions: FormQuestion[]) => {
    questions.forEach(question => {
        const index = parts.findIndex(p => p.id === question.id);

        const answers = question.answers.map(q => q.value);

        if(index === -1) {
            parts.push({
                id: question.id!,
                title: question.name.length ? question.name : question.question,
                labels: question.answers.map(q => q.label), 
                answers: [answers]
            });
        } else {
            parts[index].answers.push(answers);
        }
    });
    
    return parts;
};

interface Props {
    colors: string[];
    part: Part;
}

const CompareTable: FunctionComponent<Props> = ({ colors, part }) => {
    return (
        <HanTableContainer>
            <HanTableHead>
                { part.title }
            </HanTableHead>

            <HanTable borderOrientation={'vertical'}>
                { (part.labels.length > 0 && part.labels[0] !== '') &&
                    <HanTableRow>
                        { part.labels.map(label => (
                            <HanTableCell key={label}>{ label }</HanTableCell>
                        )) }
                    </HanTableRow>
                }

                { part.answers.map((row, rowIndex) => (
                    <HanTableRow key={rowIndex}>
                        { row.map((answer, index) => (
                            <HanTableCell key={index} style={{backgroundColor: `#${colors[rowIndex]}`, color: "white"}}>{ answer }</HanTableCell>
                        )) }
                    </HanTableRow>
                )) }
            </HanTable>
        </HanTableContainer>
    );
};

export default CompareTable;
